module.exports = __webpack_public_path__ + "static/media/YF83_7.2e439a4e.jpg";